module.exports = __webpack_public_path__ + "img/why.93374041.jpg";